function Row({ label, value }) {
  return (
    <div className="flex justify-between gap-4 py-2 border-b border-[var(--yp-border)] last:border-0 text-sm">
      <span className="text-[var(--yp-muted)]">{label}</span>
      <span className="font-medium text-right">{value || "—"}</span>
    </div>
  );
}

export default function Review({ form, selectedType, upd }) {
  return (
    <div>
      <div className="font-serif-display text-xl text-[var(--yp-primary)]">Review your request</div>
      <p className="text-sm text-[var(--yp-muted)] mt-1">Confirm the details before sending your site visit request.</p>
      <div className="mt-5">
        <Row label="Visit Type" value={selectedType?.label} />
        {form.selected_nursery && <Row label="Selected Nursery" value={form.selected_nursery} />}
        <Row label="Contact" value={`${form.full_name} · ${form.phone}`} />
        <Row label="Customer Type" value={form.customer_type} />
        <Row label="Site" value={`${form.address}, ${form.city}, ${form.state} - ${form.pincode}`} />
        <Row label="Preferred Visit" value={`${form.date} · ${form.time}`} />
        <Row label="Property" value={form.property_type} />
        <Row label="Area" value={form.area ? `${form.area} ${form.area_unit}` : "Not specified"} />
        <Row label="Requirement" value={form.needs.join(", ")} />
        <Row label="Budget" value={form.budget} />
        <Row label="Details" value={form.description} />
      </div>
      <div className="mt-4">
        <label className="flex items-start gap-2 text-sm">
          <input
            data-testid="sr-consent"
            type="checkbox"
            checked={form.consent}
            onChange={(e) => upd("consent", e.target.checked)}
            className="mt-0.5 accent-[var(--yp-primary)]"
          />
          I agree to be contacted by YourPlants regarding this site visit and related quotation/service requirements.
        </label>
      </div>
    </div>
  );
}
